/*
  lv-viewer.js: schermvullende beeldviewer op de productpagina (leverene, V51).
  Jens, 31 okt 2026: "ik wil dat op zowel desktop als mobile klanten op de productpagina de mogelijkheid hebben om de
  image groot te zien zeg maar. dus dat ze alleen de images zien en ook kunnen zoomen enzo".
  Opmaak en teksten: snippets/lv-pdp-viewer.liquid. Geen externe bibliotheken.
*/
(function () {
  'use strict';
  if (window.__lvViewer) return;
  window.__lvViewer = true;

  var SEL = '.product-information media-gallery .product-media-container';
  var HI = 2000;
  var ZOOM_DESK = 2, ZOOM_TAP = 2.5, ZOOM_MAX = 4;

  var T = {};
  try { T = JSON.parse((document.getElementById('lv-vw-i18n') || {}).textContent || '{}'); } catch (e) { T = {}; }
  function txt(k, n, total) {
    var s = T[k] || '';
    return s.replace('__N__', n).replace('__T__', total);
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function visible(el) { return !!(el && el.offsetParent !== null && el.getBoundingClientRect().width > 0); }
  function sources() {
    return Array.prototype.filter.call(document.querySelectorAll(SEL), function (c) {
      return visible(c) && c.querySelector('img');
    });
  }
  function imgUrl(img, width) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src && img.srcset) src = img.srcset.split(',')[0].trim().split(' ')[0];
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.delete('height'); u.searchParams.delete('crop');
      if (width) u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) { return src; }
  }

  // Bronbeelden toegankelijk maken: Enter of spatie opent de viewer
  function label() {
    var list = sources();
    list.forEach(function (c, i) {
      if (c.__lvVw === list.length + ':' + i) return;
      c.__lvVw = list.length + ':' + i;
      c.setAttribute('role', 'button');
      c.setAttribute('tabindex', '0');
      c.setAttribute('aria-label', txt('open', i + 1, list.length));
    });
  }

  var ov, track, countEl, live, btnClose, btnPrev, btnNext;
  var slides = [], cur = 0, opener = null, scrollY = 0, lastTouch = 0;
  var z = { s: 1, tx: 0, ty: 0 };

  function svg(d) { return '<svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>'; }
  function build() {
    if (ov) return;
    ov = document.createElement('div');
    ov.className = 'lv-vw';
    ov.hidden = true;
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', T.label || 'Images');
    ov.tabIndex = -1;
    ov.innerHTML =
      '<div class="lv-vw__track"></div>' +
      '<div class="lv-vw__count" aria-hidden="true"></div>' +
      '<div class="lv-vw__live" aria-live="polite"></div>' +
      '<button type="button" class="lv-vw__btn lv-vw__close">' + svg('M3 3 17 17M17 3 3 17') + '</button>' +
      '<button type="button" class="lv-vw__btn lv-vw__prev">' + svg('M13 3 6 10l7 7') + '</button>' +
      '<button type="button" class="lv-vw__btn lv-vw__next">' + svg('M7 3l7 7-7 7') + '</button>';
    document.body.appendChild(ov);
    track = ov.querySelector('.lv-vw__track');
    countEl = ov.querySelector('.lv-vw__count');
    live = ov.querySelector('.lv-vw__live');
    btnClose = ov.querySelector('.lv-vw__close');
    btnPrev = ov.querySelector('.lv-vw__prev');
    btnNext = ov.querySelector('.lv-vw__next');
    btnClose.setAttribute('aria-label', T.close || 'Close');
    btnPrev.setAttribute('aria-label', T.prev || 'Previous');
    btnNext.setAttribute('aria-label', T.next || 'Next');
    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { go(cur - 1); });
    btnNext.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('click', onClick);
    track.addEventListener('mousemove', onMove);
    ov.addEventListener('touchstart', onTs, { passive: false });
    ov.addEventListener('touchmove', onTm, { passive: false });
    ov.addEventListener('touchend', onTe, { passive: false });
    ov.addEventListener('touchcancel', onTe, { passive: false });
    ov.addEventListener('wheel', function (e) { e.preventDefault(); }, { passive: false });
  }

  function fill(list) {
    track.innerHTML = '';
    slides = list.map(function (c, i) {
      var srcImg = c.querySelector('img');
      var s = document.createElement('div');
      s.className = 'lv-vw__slide';
      s.setAttribute('aria-hidden', 'true');
      var fr = document.createElement('div');
      fr.className = 'lv-vw__fr';
      var im = document.createElement('img');
      im.className = 'lv-vw__img';
      im.alt = srcImg.getAttribute('alt') || '';
      im.decoding = 'async';
      im.draggable = false;
      im.src = imgUrl(srcImg, 0);
      fr.appendChild(im); s.appendChild(fr); track.appendChild(s);
      return { el: s, fr: fr, img: im, hi: imgUrl(srcImg, HI), loaded: false };
    });
  }
  function loadHi(i) {
    var sl = slides[i];
    if (!sl || sl.loaded || !sl.hi) return;
    sl.loaded = true;
    var pre = new Image();
    pre.decoding = 'async';
    pre.onload = function () { sl.img.src = sl.hi; };
    pre.src = sl.hi;
  }

  // Afmetingen van het vak en van de foto erin (contain)
  function geo(sl) {
    var W = sl.fr.clientWidth, H = sl.fr.clientHeight;
    var nw = sl.img.naturalWidth || 4, nh = sl.img.naturalHeight || 5;
    var k = Math.min(W / nw, H / nh), iw = nw * k, ih = nh * k;
    return { W: W, H: H, iw: iw, ih: ih, ox: (W - iw) / 2, oy: (H - ih) / 2 };
  }
  function axis(t, s, W, o, iw) {
    var sw = iw * s;
    if (sw <= W) return (W - sw) / 2 - o * s;
    return Math.min(-o * s, Math.max(W - (o + iw) * s, t));
  }
  function clampZ(g) { z.tx = axis(z.tx, z.s, g.W, g.ox, g.iw); z.ty = axis(z.ty, z.s, g.H, g.oy, g.ih); }
  function apply(free) {
    var sl = slides[cur]; if (!sl) return;
    sl.img.classList.toggle('is-free', !!free || reduce);
    sl.img.style.transform = 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.s + ')';
    sl.fr.classList.toggle('is-zoom', z.s > 1.01);
    sl.fr.setAttribute('aria-label', z.s > 1.01 ? (T.zoom_out || '') : (T.zoom_in || ''));
  }
  function reset(free) { z.s = 1; z.tx = 0; z.ty = 0; apply(free); }
  function pointerPan(g, mx, my) {
    var fx = Math.min(1, Math.max(0, (mx - g.ox) / g.iw)), fy = Math.min(1, Math.max(0, (my - g.oy) / g.ih));
    z.tx = g.iw * z.s > g.W ? -fx * (g.iw * z.s - g.W) - g.ox * z.s : (g.W - g.iw * z.s) / 2 - g.ox * z.s;
    z.ty = g.ih * z.s > g.H ? -fy * (g.ih * z.s - g.H) - g.oy * z.s : (g.H - g.ih * z.s) / 2 - g.oy * z.s;
  }

  // Desktop: klik zoomt 2x op de klikplek, de muis kijkt rond, nogmaals klikken zoomt terug
  var freeTimer = 0;
  function onClick(e) {
    if (Date.now() - lastTouch < 800) return;
    var sl = slides[cur]; if (!sl || !sl.fr.contains(e.target)) return;
    var r = sl.fr.getBoundingClientRect(), g = geo(sl);
    if (z.s > 1.01) { reset(false); return; }
    z.s = ZOOM_DESK; pointerPan(g, e.clientX - r.left, e.clientY - r.top); apply(false);
    clearTimeout(freeTimer);
    freeTimer = setTimeout(function () { if (z.s > 1.01) slides[cur].img.classList.add('is-free'); }, reduce ? 0 : 260);
  }
  function onMove(e) {
    if (z.s <= 1.01 || Date.now() - lastTouch < 800) return;
    var sl = slides[cur]; if (!sl) return;
    var r = sl.fr.getBoundingClientRect();
    pointerPan(geo(sl), e.clientX - r.left, e.clientY - r.top);
    sl.img.style.transform = 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.s + ')';
  }

  // Mobiel: knijpen, dubbeltikken, schuiven als ingezoomd, vegen als niet ingezoomd
  var tm = null, lastTap = { t: 0, x: 0, y: 0 };
  function pt(t, r) { return { x: t.clientX - r.left, y: t.clientY - r.top }; }
  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function onTs(e) {
    lastTouch = Date.now();
    if (e.target.closest && e.target.closest('.lv-vw__btn')) return;
    e.preventDefault();
    var sl = slides[cur]; if (!sl) return;
    var r = sl.fr.getBoundingClientRect();
    if (e.touches.length >= 2) {
      var a = e.touches[0], b = e.touches[1];
      tm = { mode: 'pinch', d0: dist(a, b) || 1, s0: z.s, tx0: z.tx, ty0: z.ty, m0: { x: (a.clientX + b.clientX) / 2 - r.left, y: (a.clientY + b.clientY) / 2 - r.top }, moved: true };
      track.classList.remove('is-drag');
      track.style.transform = 'translateX(' + (-cur * 100) + '%)';
      return;
    }
    var p = pt(e.touches[0], r);
    tm = { mode: z.s > 1.01 ? 'pan' : 'swipe', p0: p, tx0: z.tx, ty0: z.ty, t0: Date.now(), dx: 0, dir: '', moved: false };
  }
  function onTm(e) {
    lastTouch = Date.now();
    if (!tm) return;
    e.preventDefault();
    var sl = slides[cur]; if (!sl) return;
    var r = sl.fr.getBoundingClientRect(), g = geo(sl);
    if (tm.mode === 'pinch' && e.touches.length >= 2) {
      var a = e.touches[0], b = e.touches[1];
      var m = { x: (a.clientX + b.clientX) / 2 - r.left, y: (a.clientY + b.clientY) / 2 - r.top };
      var s = Math.min(ZOOM_MAX, Math.max(1, tm.s0 * dist(a, b) / tm.d0));
      var cx = (tm.m0.x - tm.tx0) / tm.s0, cy = (tm.m0.y - tm.ty0) / tm.s0;
      z.s = s; z.tx = m.x - cx * s; z.ty = m.y - cy * s; clampZ(g); apply(true);
      return;
    }
    var p = pt(e.touches[0], r);
    var dx = p.x - tm.p0.x, dy = p.y - tm.p0.y;
    if (Math.abs(dx) > 8 || Math.abs(dy) > 8) tm.moved = true;
    if (tm.mode === 'pan') {
      z.tx = tm.tx0 + dx; z.ty = tm.ty0 + dy; clampZ(g); apply(true);
    } else if (tm.mode === 'swipe') {
      if (!tm.dir && tm.moved) tm.dir = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      if (tm.dir === 'x') {
        var edge = (cur === 0 && dx > 0) || (cur === slides.length - 1 && dx < 0);
        tm.dx = edge ? dx / 3 : dx;
        track.classList.add('is-drag');
        track.style.transform = 'translateX(calc(' + (-cur * 100) + '% + ' + tm.dx + 'px))';
      }
    }
  }
  function onTe(e) {
    lastTouch = Date.now();
    if (!tm) return;
    var sl = slides[cur]; if (!sl) { tm = null; return; }
    var r = sl.fr.getBoundingClientRect(), g = geo(sl);
    if (tm.mode === 'pinch') {
      if (z.s < 1.05) reset(false);
      if (e.touches.length === 1) {
        tm = { mode: z.s > 1.01 ? 'pan' : 'idle', p0: pt(e.touches[0], r), tx0: z.tx, ty0: z.ty, t0: Date.now(), dx: 0, dir: '', moved: true };
      } else tm = null;
      return;
    }
    if (e.touches.length) return;
    var t = tm; tm = null;
    if (t.mode === 'swipe' && t.dir === 'x') {
      track.classList.remove('is-drag');
      var v = Math.abs(t.dx) / Math.max(1, Date.now() - t.t0);
      if (Math.abs(t.dx) > g.W * 0.18 || (Math.abs(t.dx) > 30 && v > 0.4)) go(cur + (t.dx < 0 ? 1 : -1));
      else go(cur);
      return;
    }
    if (!t.moved && Date.now() - t.t0 < 350) {
      var now = Date.now();
      if (now - lastTap.t < 320 && Math.hypot(t.p0.x - lastTap.x, t.p0.y - lastTap.y) < 40) {
        lastTap.t = 0;
        if (z.s > 1.01) reset(false);
        else {
          var cx = (t.p0.x - z.tx) / z.s, cy = (t.p0.y - z.ty) / z.s;
          z.s = ZOOM_TAP; z.tx = t.p0.x - cx * z.s; z.ty = t.p0.y - cy * z.s; clampZ(g); apply(false);
        }
      } else lastTap = { t: now, x: t.p0.x, y: t.p0.y };
    }
  }

  function go(i) {
    if (!slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    if (i !== cur) { reset(true); slides[cur].el.setAttribute('aria-hidden', 'true'); }
    cur = i;
    slides[cur].el.removeAttribute('aria-hidden');
    track.classList.remove('is-drag');
    track.style.transform = 'translateX(' + (-cur * 100) + '%)';
    countEl.textContent = (cur + 1) + ' / ' + slides.length;
    live.textContent = txt('position', cur + 1, slides.length);
    btnPrev.disabled = cur === 0;
    btnNext.disabled = cur === slides.length - 1;
    btnPrev.hidden = btnNext.hidden = slides.length < 2;
    z.s = 1; z.tx = 0; z.ty = 0; apply(true);
    loadHi(cur); loadHi(cur + 1); loadHi(cur - 1);
  }

  function focusables() {
    return [btnClose, btnPrev, btnNext].filter(function (b) { return !b.hidden && !b.disabled && visible(b); });
  }
  function onKey(e) {
    if (!ov || ov.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    else if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) { e.preventDefault(); return; }
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
    }
  }

  function open(index, from) {
    var list = sources();
    if (!list.length) return;
    build();
    opener = from || null;
    fill(list);
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    document.documentElement.classList.add('lv-vw-lock');
    b.style.position = 'fixed'; b.style.top = (-scrollY) + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    ov.hidden = false;
    cur = 0;
    track.classList.add('is-drag');
    go(Math.max(0, Math.min(list.length - 1, index)));
    void ov.offsetWidth;
    track.classList.remove('is-drag');
    ov.classList.add('is-open');
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('resize', onResize);
    btnClose.focus({ preventScroll: true });
  }
  function close() {
    if (!ov || ov.hidden) return;
    document.removeEventListener('keydown', onKey, true);
    window.removeEventListener('resize', onResize);
    ov.classList.remove('is-open');
    ov.hidden = true;
    track.innerHTML = ''; slides = [];
    var b = document.body, html = document.documentElement;
    html.classList.remove('lv-vw-lock');
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    // Eerst de focus terug op het beeld, dan pas de scrollpositie: focus kan de pagina laten verschuiven
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
    var prev = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, scrollY);
    html.style.scrollBehavior = prev;
  }
  function onResize() { if (slides[cur]) reset(true); }

  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest(SEL);
    if (!c || !c.querySelector('img') || e.defaultPrevented) return;
    var list = sources(), i = list.indexOf(c);
    if (i < 0) return;
    e.preventDefault();
    open(i, c);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var c = e.target.closest && e.target.closest(SEL);
    if (!c || e.target !== c) return;
    var list = sources(), i = list.indexOf(c);
    if (i < 0) return;
    e.preventDefault();
    open(i, c);
  });

  function init() {
    label();
    var root = document.querySelector('.product-information');
    if (root && 'MutationObserver' in window) {
      var t = 0;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(label, 150); }).observe(root, { childList: true, subtree: true });
    }
    window.addEventListener('resize', function () { clearTimeout(init.__r); init.__r = setTimeout(label, 200); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
